/**
 * Procedure Categories and Procedures for DM in Clinical Pharmacology students
 * Extracted with strict evidence from official NMC PDF (Page 5, 11-13: "Psychomotor domain - Psychomotor skills")
 */
export const CLINICAL_PHARMACOLOGY_PROCEDURES = {
  "Clinical Pharmacokinetic (PK) & Therapeutic Drug Monitoring (TDM) Procedures": [
    "High-Performance Liquid Chromatography (HPLC) & Spectrophotometric PK Assays",
    "Therapeutic Drug Monitoring (TDM) & Dosing Adjustment (Phenytoin, Antiepileptics, Immunosuppressants, Aminoglycosides)",
    "Pharmacogenomic Variant Screening for Dose Optimization",
    "Estimation of Orocecal Transit Time (Sulphapyridine Method) & Oxidative Stress Marker Profiling",
  ],
  "Clinical Pharmacodynamic (PD) & Volunteer Safety Procedures": [
    "Non-Invasive Ambulatory BP & Treadmill / Ergometer Exercise Hemodynamic Monitoring",
    "12-Lead Electrocardiography (ECG) Recording & Interpretation",
    "Spirometry / Pulmonary Function Testing & Bronchodilator Reversibility Assessment",
    "Volunteer Analgesic Activity & Cold Pressor Pain Model Testing",
    "Pupillary Response Measurement for Ocular & Anticholinergic Drugs",
  ],
  "Clinical Trial Design, Pharmacovigilance & Drug Regulation Exercises": [
    "Phase I-IV Clinical Trial Protocol, BA/BE Protocol, ICF & CRF Development",
    "Clinical Trial Randomization, Blinding & Allocation Concealment Execution",
    "Adverse Drug Reaction (ADR) & Serious Adverse Event (SAE) Reporting and Causality Assessment",
    "Medication Error Audit & Hospital Antimicrobial Stewardship Policy Formulation",
    "Essential Medicine List (EML) & Hospital Formulary Development",
  ],
};

export const CLINICAL_PHARMACOLOGY_CATEGORIES = Object.keys(CLINICAL_PHARMACOLOGY_PROCEDURES);

export const isDMInClinicalPharmacologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("clinical pharmacology");
};
